// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.vote-filters-container {
  width: 100%;
  background: #0e1b1b;
  border-bottom: 1px solid #1a2c2c;
  padding: 12px 0;
  position: sticky;
  top: 0;
  z-index: 100;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  display: flex;
  align-items: center;
  position: relative;
}

.vote-filters-scroll {
  display: flex;
  gap: 8px;
  padding: 0 16px;
  overflow-x: auto;
  scroll-behavior: smooth;
  /* Hide scrollbars for a clean look */
  scrollbar-width: none;
  -ms-overflow-style: none;
  flex: 1 1;
}

/* Custom scrollbar styling for webkit browsers */
.vote-filters-scroll::-webkit-scrollbar {
  display: none;
}

.scroll-arrow {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #0e1b1b;
  border: none;
  color: #5AAF9A;
  cursor: pointer;
  z-index: 10;
  padding: 0 8px;
  height: 40px;
  transition: all 0.2s ease;
}

.scroll-arrow:hover {
  color: #72d9c0;
  transform: scale(1.1);
}

.left-arrow {
  box-shadow: 15px 0px 20px -5px #0e1b1b;
}

.right-arrow {
  box-shadow: -15px 0px 20px -5px #0e1b1b;
}

.vote-filter-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  background: #142222;
  border: 1px solid #233737;
  border-radius: 20px;
  color: #cfdada;
  font-size: 14px;
  font-weight: 500;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.2s ease;
  flex-shrink: 0;
  min-height: 40px;
  -webkit-user-select: none;
          user-select: none;
  outline: none;
  position: relative;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}

.vote-filter-button:hover {
  background: #1b2e2e;
  border-color: #5AAF9A;
  color: #ffffff;
  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.25);
}

.vote-filter-button.active {
  background: #5AAF9A;
  border-color: #5AAF9A;
  color: #091919;
  font-weight: 600;
  box-shadow: 0 2px 10px rgba(90, 175, 154, 0.35);
}

.vote-filter-button.active:hover {
  background: #6bc2ad;
  border-color: #6bc2ad;
  color: #091919;
}

.vote-filter-button:focus-visible {
  box-shadow: 0 0 0 2px rgba(90, 175, 154, 0.4);
}

.vote-filter-button:active {
  transform: scale(0.97);
}

.filter-icon {
  font-size: 16px;
  line-height: 1;
}

.filter-label {
  font-size: 14px;
  line-height: 1.2;
}

/* Mobile responsiveness */
@media (max-width: 768px) {
  .scroll-arrow {
    display: none;
  }
  
  .vote-filters-container {
    padding: 8px 0;
    /* Add subtle gradient indicators for scrollable content */
    position: relative;
  }
  
  .vote-filters-container::before,
  .vote-filters-container::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    width: 20px;
    pointer-events: none;
    z-index: 10;
  }
  
  .vote-filters-container::before {
    left: 0;
    background: linear-gradient(to right, #0e1b1b, transparent);
  }
  
  .vote-filters-container::after {
    right: 0;
    background: linear-gradient(to left, #0e1b1b, transparent);
  }
  
  .vote-filters-scroll {
    padding: 0 12px;
    gap: 6px;
    /* Enhanced touch scrolling */
    -webkit-overflow-scrolling: touch;
    overscroll-behavior-x: contain;
  }
  
  .vote-filter-button {
    padding: 6px 12px;
    font-size: 13px;
    min-height: 36px;
    /* Better touch targets */
    min-width: 44px;
  }
  
  .filter-icon {
    font-size: 14px;
  }
  
  .filter-label {
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .vote-filters-container {
    padding: 6px 0;
  }
  
  .vote-filters-scroll {
    padding: 0 8px;
    gap: 4px;
  }
  
  .vote-filter-button {
    padding: 5px 10px;
    font-size: 12px;
    min-height: 32px;
    min-width: 40px;
  }
  
  .filter-icon {
    font-size: 12px;
  }
  
  .filter-label {
    font-size: 12px;
  }
}

/* Extra small devices */
@media (max-width: 360px) {
  .vote-filters-container {
    padding: 4px 0;
  }
  
  .vote-filters-scroll {
    padding: 0 6px;
    gap: 3px;
  }
  
  .vote-filter-button {
    padding: 4px 8px;
    font-size: 11px;
    min-height: 28px;
    min-width: 36px;
  }
  
  .filter-icon {
    font-size: 11px;
  }
  
  .filter-label {
    font-size: 11px;
  }
}

/* Remove the bottom scroll indicator as it's not needed for horizontal scrolling */
`, "",{"version":3,"sources":["webpack://./src/Components/VoteFilters/VoteFilters.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,mBAAmB;EACnB,gCAAgC;EAChC,eAAe;EACf,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,qCAAqC;EACrC,qBAAqB;EACrB,wBAAwB;EACxB,SAAO;AACT;;AAEA,iDAAiD;AACjD;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,WAAW;EACX,cAAc;EACd,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,gBAAgB;EAChB,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA,0BAA0B;AAC1B;EACE;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,0DAA0D;IAC1D,kBAAkB;EACpB;;EAEA;;IAEE,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,SAAS;IACT,WAAW;IACX,oBAAoB;IACpB,WAAW;EACb;;EAEA;IACE,OAAO;IACP,2DAA2D;EAC7D;;EAEA;IACE,QAAQ;IACR,0DAA0D;EAC5D;;EAEA;IACE,eAAe;IACf,QAAQ;IACR,6BAA6B;IAC7B,iCAAiC;IACjC,8BAA8B;EAChC;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,wBAAwB;AACxB;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,QAAQ;EACV;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA,mFAAmF","sourcesContent":[".vote-filters-container {\n  width: 100%;\n  background: #0e1b1b;\n  border-bottom: 1px solid #1a2c2c;\n  padding: 12px 0;\n  position: sticky;\n  top: 0;\n  z-index: 100;\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n  display: flex;\n  align-items: center;\n  position: relative;\n}\n\n.vote-filters-scroll {\n  display: flex;\n  gap: 8px;\n  padding: 0 16px;\n  overflow-x: auto;\n  scroll-behavior: smooth;\n  /* Hide scrollbars for a clean look */\n  scrollbar-width: none;\n  -ms-overflow-style: none;\n  flex: 1;\n}\n\n/* Custom scrollbar styling for webkit browsers */\n.vote-filters-scroll::-webkit-scrollbar {\n  display: none;\n}\n\n.scroll-arrow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: #0e1b1b;\n  border: none;\n  color: #5AAF9A;\n  cursor: pointer;\n  z-index: 10;\n  padding: 0 8px;\n  height: 40px;\n  transition: all 0.2s ease;\n}\n\n.scroll-arrow:hover {\n  color: #72d9c0;\n  transform: scale(1.1);\n}\n\n.left-arrow {\n  box-shadow: 15px 0px 20px -5px #0e1b1b;\n}\n\n.right-arrow {\n  box-shadow: -15px 0px 20px -5px #0e1b1b;\n}\n\n.vote-filter-button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 8px 16px;\n  background: #142222;\n  border: 1px solid #233737;\n  border-radius: 20px;\n  color: #cfdada;\n  font-size: 14px;\n  font-weight: 500;\n  white-space: nowrap;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  flex-shrink: 0;\n  min-height: 40px;\n  user-select: none;\n  outline: none;\n  position: relative;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n}\n\n.vote-filter-button:hover {\n  background: #1b2e2e;\n  border-color: #5AAF9A;\n  color: #ffffff;\n  box-shadow: 0 3px 8px rgba(0, 0, 0, 0.25);\n}\n\n.vote-filter-button.active {\n  background: #5AAF9A;\n  border-color: #5AAF9A;\n  color: #091919;\n  font-weight: 600;\n  box-shadow: 0 2px 10px rgba(90, 175, 154, 0.35);\n}\n\n.vote-filter-button.active:hover {\n  background: #6bc2ad;\n  border-color: #6bc2ad;\n  color: #091919;\n}\n\n.vote-filter-button:focus-visible {\n  box-shadow: 0 0 0 2px rgba(90, 175, 154, 0.4);\n}\n\n.vote-filter-button:active {\n  transform: scale(0.97);\n}\n\n.filter-icon {\n  font-size: 16px;\n  line-height: 1;\n}\n\n.filter-label {\n  font-size: 14px;\n  line-height: 1.2;\n}\n\n/* Mobile responsiveness */\n@media (max-width: 768px) {\n  .scroll-arrow {\n    display: none;\n  }\n  \n  .vote-filters-container {\n    padding: 8px 0;\n    /* Add subtle gradient indicators for scrollable content */\n    position: relative;\n  }\n  \n  .vote-filters-container::before,\n  .vote-filters-container::after {\n    content: '';\n    position: absolute;\n    top: 0;\n    bottom: 0;\n    width: 20px;\n    pointer-events: none;\n    z-index: 10;\n  }\n  \n  .vote-filters-container::before {\n    left: 0;\n    background: linear-gradient(to right, #0e1b1b, transparent);\n  }\n  \n  .vote-filters-container::after {\n    right: 0;\n    background: linear-gradient(to left, #0e1b1b, transparent);\n  }\n  \n  .vote-filters-scroll {\n    padding: 0 12px;\n    gap: 6px;\n    /* Enhanced touch scrolling */\n    -webkit-overflow-scrolling: touch;\n    overscroll-behavior-x: contain;\n  }\n  \n  .vote-filter-button {\n    padding: 6px 12px;\n    font-size: 13px;\n    min-height: 36px;\n    /* Better touch targets */\n    min-width: 44px;\n  }\n  \n  .filter-icon {\n    font-size: 14px;\n  }\n  \n  .filter-label {\n    font-size: 13px;\n  }\n}\n\n@media (max-width: 480px) {\n  .vote-filters-container {\n    padding: 6px 0;\n  }\n  \n  .vote-filters-scroll {\n    padding: 0 8px;\n    gap: 4px;\n  }\n  \n  .vote-filter-button {\n    padding: 5px 10px;\n    font-size: 12px;\n    min-height: 32px;\n    min-width: 40px;\n  }\n  \n  .filter-icon {\n    font-size: 12px;\n  }\n  \n  .filter-label {\n    font-size: 12px;\n  }\n}\n\n/* Extra small devices */\n@media (max-width: 360px) {\n  .vote-filters-container {\n    padding: 4px 0;\n  }\n  \n  .vote-filters-scroll {\n    padding: 0 6px;\n    gap: 3px;\n  }\n  \n  .vote-filter-button {\n    padding: 4px 8px;\n    font-size: 11px;\n    min-height: 28px;\n    min-width: 36px;\n  }\n  \n  .filter-icon {\n    font-size: 11px;\n  }\n  \n  .filter-label {\n    font-size: 11px;\n  }\n}\n\n/* Remove the bottom scroll indicator as it's not needed for horizontal scrolling */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
